<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <p class="mb-6 form__title primary--text">
            MINUTA DECLINADA PELA SEGURADORA
          </p>
        </v-col>
        <v-col cols="12" class="pb-7">
          <BaseFormTextArea
            id-element="reasonCancelEndorsement"
            placeholder="Inserir"
            v-model="form.comentario"
            :rules="[requiredInput, maxLengthTextArea]"
            label-text="Comentário"
          />
        </v-col>
        <v-col cols="12">
          <p class="primary--text mb-2 body-2 font-weight-bold">
            Anexar documentos (se necessários)
          </p>
          <DropFile @selected-files="addFiles" :multiple="true" class="mb-5" />
          <DocumentDataTable
            v-if="documents.length > 0"
            :documents="documents"
            @preview-file="onPreviewFile"
            @remove-file="onRemoveFile"
          />
        </v-col>
      </v-row>
      <BaseFooter>
        <v-row>
          <v-spacer />
          <v-col cols="12" sm="5" md="3" xl="2">
            <BaseButton
              v-html="'ENVIAR'"
              class="white--text pink"
              width="100%"
              @click="openModal"
            />
          </v-col>
        </v-row>
      </BaseFooter>
    </v-form>
    <ModalGenericCriticism
      v-model="modal"
      @close="closeModal"
      :title="title"
      :text="text"
      :text-button="textButton"
      :has-cancel-button="hasCancelButton"
      :class-button="classButton"
    />
  </Main>
</template>
<script>
import DocumentDataTable from "@/components/DocumentDataTable";
import DropFile from "@/components/DropFile";
import { FILE, documentAlreadyUploaded } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ModalGenericCriticism from "../components/ModalGenericCriticism";
import { requiredInput, maxLengthTextArea } from "@/utils/rules.js";
export default {
  data: () => ({
    documents: [],
    form: {
      anexos: [],
      comentario: null
    },
    errorMessages: [],
    modal: false,
    breadcrumb: [
      {
        text: "Cotação",
        to: "quotation element"
      }
    ],
    hasCancelButton: false,
    title: null,
    text: null,
    textButton: null,
    confirmSubmit: false,
    classButton: null,
    requiredInput,
    maxLengthTextArea
  }),
  components: {
    DocumentDataTable,
    DropFile,
    ModalGenericCriticism
  },
  mixins: [DocumentsMixin, LoadingRequest],
  created() {
    this.fetchQuotation();
  },
  computed: {
    ...mapState("quotation", ["currentQuotation"]),
    quotationId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestDeclineDraftContract",
      "requestCurrentQuotation"
    ]),
    fetchQuotation() {
      if (_.isEmpty(this.currentQuotation)) {
        this.withLoading(this.requestCurrentQuotation(this.quotationId));
      } else {
        this.updateBreadcrumb();
      }
    },
    previousPage() {
      this.$router.push({
        name: "quotation criticism",
        params: { id: this.quotationId }
      });
    },
    addFiles(files) {
      this.documents = this.documents.concat(
        files.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
    },
    onRemoveFile(item) {
      this.documents = this.documents.filter(
        document => document.arquivo.nome !== item.arquivo.nome
      );
    },
    validate() {
      return this.$refs.form.validate() && this.validateMessage();
    },
    validateMessage() {
      this.errorMessages = !this.form.comentario
        ? ["É preciso fazer um comentário sobre o declínio"]
        : [];
      return this.form.comentario;
    },
    async submit() {
      if (!this.validate()) return;
      this.form.anexos = _.map(await this.submitFiles(), "arquivo");
      this.withLoading(
        this.requestDeclineDraftContract(this.getPayloadDecline()).then(() => {
          this.title = "MINUTA DECLINADA";
          this.text = "A minuta foi declinada";
          this.hasCancelButton = false;
          this.confirmSubmit = false;
          this.textButton = "OK";
          this.classButton = "secondary";
          this.modal = true;
        })
      );
    },
    submitFiles() {
      const { uploadDocument } = this;
      return Promise.all(
        _.map(this.documents, document =>
          documentAlreadyUploaded(document)
            ? Promise.resolve(document)
            : uploadDocument(document.arquivo[FILE], (file, arquivo) => ({
                arquivo
              }))
        )
      );
    },
    getPayloadDecline() {
      return {
        id: this.quotationId,
        payload: this.form
      };
    },
    redirectToQuotation() {
      this.modal = false;
      this.$router.push({
        name: "quotation element",
        params: { id: this.quotationId }
      });
    },
    closeModal(value) {
      this.modal = false;
      value &&
        ((this.confirmSubmit && this.submit()) || this.redirectToQuotation());
    },
    openModal() {
      this.confirmSubmit = true;
      this.title = "CONFIRMAR";
      this.hasCancelButton = true;
      this.text = "Confirma o Declínio de Minuta pela Seguradora?";
      this.textButton = "SIM";
      this.classButton = "white--text pink";
      this.modal = true;
    },
    updateBreadcrumb() {
      this.breadcrumb = [
        {
          text: `Cotação - ${this.currentQuotation.numero}`,
          to: "quotation element"
        }
      ];
    }
  },
  watch: {
    currentQuotation() {
      this.updateBreadcrumb();
    }
  }
};
</script>
